module.exports = __webpack_public_path__ + "static/media/17.d3cf2e34.mp3";